import { render, staticRenderFns } from "./ReadonlyComment.vue?vue&type=template&id=0192c869"
import script from "./ReadonlyComment.vue?vue&type=script&lang=js"
export * from "./ReadonlyComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports